import { EStorageKeys } from '@qsp-ui-library/models/enums/storage-keys.enum';
import { ESupportedLanguage, ESupportedRegionLanguage } from '@qsp-ui-library/models/enums/supported-language.enum';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const lang = localStorage.getItem(EStorageKeys.LOCALE_LANGUAGE) || ESupportedLanguage.ENGLISH;
    let regionLang: string;

    switch (lang) {
      case ESupportedLanguage.CHINESE:
        regionLang = ESupportedRegionLanguage.CHINESE_SIMPLE;
        break;
      case ESupportedLanguage.ENGLISH:
        regionLang = ESupportedRegionLanguage.ENGLISH_US;
        break;
      case ESupportedLanguage.PORTUGUESE:
        regionLang = ESupportedRegionLanguage.PORTUGUESE_PORTUGAL;
        break;
      case ESupportedLanguage.SPANISH:
        regionLang = ESupportedRegionLanguage.SPANISH_SPAIN;
        break;
      default:
        regionLang = ESupportedRegionLanguage.ENGLISH_US;
    }

    const cloned = req.clone({
      setHeaders: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Accept-Language': regionLang,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'X-Lang': regionLang,
      },
    });

    return next.handle(cloned);
  }
}
